import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { isAuthenticated } from '../utils'

import Main from './Main'
import Footer from './Footer'
import Sidebar from './Sidebar'
import SubHeader from './SubHeader'

const PrivateRoute = ({
  component: Component,
  withSidebar,
  withSubHeader,
  hideSearch,
  hideTitle,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => (
        <WrappedComponent
          withSidebar={withSidebar}
          withSubHeader={withSubHeader}
          hideSearch={hideSearch}
          hideTitle={hideTitle}
        >
          {isAuthenticated() ? (
            <Component {...props} />
          ) : (
            <Redirect to='/login' />
          )}
        </WrappedComponent>
      )}
    />
  )
}

const WrappedComponent = ({
  children,
  withSidebar,
  withSubHeader,
  hideSearch,
  hideTitle
}) => {
  return (
    <>
      <Main>
        {withSubHeader && (
          <SubHeader hideSearch={hideSearch} hideTitle={hideTitle} />
        )}
        <div className='d-flex flex-grow-1 flex-row my-4'>
          {withSidebar && <Sidebar />}
          <main className='d-flex flex-grow-1'>{children}</main>
        </div>
      </Main>
      <Footer />
    </>
  )
}

export const PrivateRouteWithSidebarAndSubHeader = ({ component, ...rest }) => {
  return (
    <PrivateRoute
      {...rest}
      withSidebar
      withSubHeader
      hideSearch={false}
      component={component}
      hideTitle={false}
    />
  )
}

export default PrivateRoute
